import apiClient from './api';

// 院系API服务
export const facultyService = {
  /**
   * 获取院系详情
   * @param {string} universitySlug - 大学slug（name_en_concat或id）
   * @param {string} facultySlug - 院系slug（name_en_concat或id）
   * @returns {Promise} 院系详情
   */
  getFacultyDetail: (universitySlug, facultySlug) => {
    return apiClient.get(`/api/universities/${universitySlug}/faculties/${facultySlug}`);
  },

  /**
   * 获取院系的专业列表
   * @param {string} universitySlug - 大学slug
   * @param {string} facultySlug - 院系slug
   * @param {Object} params - 查询参数
   * @returns {Promise} 专业列表
   */
  getFacultyPrograms: (universitySlug, facultySlug, params = {}) => {
    const queryParams = {
      page: params.page || 1,
      size: params.size || 15,
      academic_degree: params.academic_degree || ''
    };

    const filteredParams = Object.fromEntries(
      Object.entries(queryParams).filter(([_, value]) => 
        value !== null && value !== undefined && value !== ''
      )
    );

    return apiClient.get(`/api/universities/${universitySlug}/faculties/${facultySlug}/programs`, { params: filteredParams });
  }
};

// 院系数据转换工具函数
export const facultyDataMapper = {
  /**
   * 将后端院系数据转换为前端格式
   * @param {Object} apiFaculty - 后端院系数据
   * @returns {Object} 前端院系数据格式
   */
  mapFacultyFromApi: (apiFaculty) => {
    return {
      id: apiFaculty.id,
      name: apiFaculty.name_cn || '',
      nameEn: apiFaculty.name_en || '',
      name_en_concat: apiFaculty.name_en_concat || '',
      director: apiFaculty.director || '-',
      teachers: apiFaculty.number_of_teachers || '-',
      students: apiFaculty.number_of_students || '-',
      university: apiFaculty.university ? {
        id: apiFaculty.university.id,
        name: apiFaculty.university.name_cn || '',
        nameEn: apiFaculty.university.name_en || '',
        name_en_concat: apiFaculty.university.name_en_concat || '',
        logo: apiFaculty.university.logo || ''
      } : {
        id: '',
        name: '',
        nameEn: '',
        name_en_concat: '',
        logo: ''
      },
      programs: (apiFaculty.programs || []).map(program => ({
        id: program.id,
        name: program.name_cn || '',
        nameEn: program.name_en || '',
        level: program.academic_degree || '-',
        mode: program.mode || '课程型',
        duration: program.duration || '-',
        credits: program.credits || '-',
        tuitionFee: program.fees_total || program.fees_tuition,
        totalFee: program.fees_total || '-',
        currency: program.currency || 'MYR',
        interview: program.is_interview ? '是' : '否',
        portfolio: program.is_portfolio || false,
        crossMajor: program.is_interdisciplinary || false,
        intakes: Array.isArray(program.intakes)
          ? program.intakes
          : (typeof program.intakes === 'string'
              ? program.intakes.split(/[.,，\/\s]+/).filter(Boolean)
              : []),
        ranking: program.ranking_qs || '-',
        tags: [],
        featured: false
      })),
      media: {
        images: apiFaculty.media_images || [],
        files: apiFaculty.media_files || []
      },
      content: {
        intro: (apiFaculty.intros || []).map(intro => ({ content: intro.content })),
        advantages: (apiFaculty.advantages || []).map(advantage => ({ content: advantage.content }))
      }
    };
  }
};

export default facultyService;
